<template>
  <b-dropdown
    variant="outline-default"
    menu-class="menu-shadow scrollable text-medium"
    toggle-class="rounded-pill flex-center justify-content-between"
  >
    <template slot="button-content">
      <div class="text-truncate button-content">
        {{ value && value.name }}
      </div>
    </template>
    <b-dropdown-item
      v-for="interval in filterIntervals"
      :key="interval.id"
      @click="onChange(interval)"
      >{{ interval.name }}</b-dropdown-item
    >
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import { filterIntervals } from '@/interval'

/**
 * This provides a dropdown to choose a timeline from. It supports v-model
 * props:
 *  - value
 * @emits
 *  - input
 */
export default {
  name: 'TimelineFilterDropdown',
  props: ['value'],
  components: {
    BDropdown,
    BDropdownItem
  },
  data() {
    return {
      filterIntervals: filterIntervals()
    }
  },
  methods: {
    onChange(interval) {
      this.$emit('input', interval)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

$dropdown-width: 130px;

/deep/ button {
  text-align: left;
  border-color: $borderPrimary;
}
/deep/ .button-content {
  width: $dropdown-width;
}
/deep/ .dropdown-menu {
  left: 14px !important;
  min-width: ($dropdown-width + 10px);
}
</style>
